export { Textarea } from "@mantine/core";
export type { TextareaProps } from "@mantine/core";
export { getTextareaOverrides } from "./Textarea.styled";
